import { Directive, Input } from '@angular/core';

import { WdOriginType } from '../../models/telemetry-constants.model';
import { MruFileItem } from '../../mru/mru-file-item.model';
import { WacContentService } from '../../services/wac-content.service';
import { CapabilitiesService } from '../../shared-context/capabilities.service';
import { HoverActionDirective } from './hover-action.directive';

@Directive({
    selector: '[ohpWacHoverPreboot]'
})
export class WacHoverPrebootDirective extends HoverActionDirective {

    @Input('ohpWacHoverPreboot') private readonly itemInfo: { item: MruFileItem, wdOriginType: WdOriginType };

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly wacContentService: WacContentService
    ) {
        super(() => this.wacContentService.prebootDocument(this.itemInfo.item, this.itemInfo.wdOriginType));
    }

    protected enabled() {
        return this.capabilitiesService.wacHostEnabledForFileType(this.itemInfo.item.fileType) && this.capabilitiesService.wacHostHoverPrebootEnabledForFileType(this.itemInfo.item.fileType);
    }
}
